<template>
  <div>
    <div class="header fixed" :class="{ opacity: menu.opacity && menuOpacity }">
      <div class="g-box">
        <router-link to="/" class="header-logo"></router-link>
        <div class="header-nave mla" ref="headerNave">
          <div class="header-nave-item">
            <router-link to="/" class="header-nave-cap">首页</router-link>
          </div>
          <div
            v-for="(item, index) in menu.list"
            :key="index"
            class="header-nave-item"
            @mouseleave="handleMouseOut"
            @mouseenter="handleMouseEnter(item, index)"
            :class="{ subOpen: menu.ind === index && menu.subOpen }"
            v-show="item.status"
          >
            <div
              class="header-nave-cap"
              :class="{ on: menu.ind === index }"
              @click="onMenuClick(item)"
            >
              {{ item.name }}
            </div>
            <div
              class="header-nave-box"
              v-if="
                item.subMenus.length > 1 ||
                  (item.subMenus[0] && item.subMenus[0].name !== item.name)
              "
            >
              <!-- || item.subMenus[0].name !== item.name -->
              <!-- :to="item2.path" -->
              <div
                v-for="item2 in item.subMenus"
                :key="item2.id"
                @click="toSubMenu(item2, item)"
                class="header-nave-box-item"
              >
                {{ item2.name }} >
              </div>

              <!-- <c-link
                v-for="(item2, index2) in item.subMenus"
                :key="index2"
                :to="item2.path"
                @click="toSubMenu(item, item2)"
                class="box-item"
                :class="{ on: menu.ind === index && menu.subInd === index2 }"
                :blank="item2.openType === 1"
                >{{ item2.name }}</c-link
              > -->
            </div>
          </div>
        </div>
        <div class="menu-make" :style="{ height: menuMakeHeight + 'px' }"></div>
        <!-- <div class="header-tel">
          <div class="header-tel-ico m-h"></div>
          <div class="header-tel-box">咨询电话：{{ tempTel }}</div>
        </div> -->
      </div>
    </div>
    <div class="header-h" v-if="!menu.opacity"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import pageMain_mx from "../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      menuOpacity: true,
      opacityTopPrev: 0,
      tempTel: "",
      menuMakeHeight: 0
    };
  },
  computed: mapState({
    menu: state => state.main.menu
  }),
  mounted() {
    window.addEventListener("scroll", this.winScroll);
  },
  methods: {
    async handleMouseEnter(item, index) {
      // item.on = true;
      await this.$nextTick();

      // // 计算高度
      const el = document.querySelector(
        `.header .header-nave-item:nth-child(${index + 2}) .header-nave-box`
      );
      this.menuMakeHeight = el && el.clientHeight + 8;
    },
    handleMouseOut() {
      this.menuMakeHeight = 0;
    },
    async init() {
      this.tempTel = await this.getMenuConfig("咨询电话", "title");
    },
    winScroll() {
      const { opacityTop, opacity, subOpen } = this.menu;
      const { scrollY } = window;

      if (opacity) {
        this.menuOpacity = scrollY <= opacityTop;
      } else {
        this.menuOpacity = true;
      }

      // 子菜单显示
      const _subOpen = scrollY < this.opacityTopPrev;
      if (subOpen !== _subOpen) {
        this.$store.commit("menuSet", { subOpen: _subOpen });
      }
      this.opacityTopPrev = scrollY;
    },
    onMenuClick(item) {
      if (item.subMenus.length === 1 && item.name === item.subMenus[0].name) {
        this.toMenu(item.subMenus[0].pageType, item.subMenus[0].id);
        // this.$router.push({
        //   path: "/concact_us",
        //   query: {
        //     id: item.subMenus[0].id
        //   }
        // });
      }
      // try {
      //   this.$refs["headerNave"].children[
      //     ind + 1
      //   ].children[1].children[0].children[0].click();
      // } catch (e) {
      //   console.log(e)
      // }
    },
    async toSubMenu(item, item2) {
      this.toMenu(item.pageType, item.id);
      console.log(item, "subitem");
      console.log(item2, "item");
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.winScroll);
  }
};
</script>
<style lang="less">
.header {
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  position: relative;

  .g-box {
    display: flex;
    align-items: center;
    height: 88px;
  }
  &.opacity {
    background-color: rgba(0, 0, 0, 0.2);

    border-bottom-color: transparent;
    .header-logo {
      background-image: url("../assets/img/ico_1.png");
    }
    .header-nave-cap {
      color: #ffffff;
    }
    .header-tel-ico {
      background-image: url("../assets/img/ico_9.png");
    }
  }
  &.fixed {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 1200px;
    // background-color: rgba(0, 0, 0, 0.07);

    z-index: 100;
  }
}
.header-h {
  height: 88px;
}
.header-logo {
  display: block;
  background: url("../assets/img/ico_2.png") no-repeat;
  width: 98px;
  height: 41px;
}
.header-nave {
  display: flex;
}
.header-nave-item {
  position: relative;
  padding: 0 25px;
  height: 88px;
  line-height: 88px;
  box-sizing: border-box;

  &:hover {
    .header-nave-box {
      transform: scale(1, 1);
      transition: transform 0s;
      z-index: 1;
    }
  }
  &.subOpen {
    .header-nave-box {
      transform: scale(1, 1);
      transition: transform 0.3s;
    }
  }
}
.header-nave-cap {
  color: #282828;
  font-size: 18px;
  position: relative;
  cursor: pointer;
  &.on {
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 52px;
      margin-left: -18px;
      width: 36px;
      height: 4px;
      background: rgba(82, 151, 224, 1);
    }
  }
  &:hover {
    opacity: 0.8;
  }
}
.header-nave-box {
  position: absolute;
  left: 0;
  top: 89px;
  width: 100%;
  // background-color: #fff;
  padding: 19px 0;
  transform: scale(1, 0);
  // transform: scale(1, 1);

  transform-origin: top;
  transition: transform 0.1s;
  display: flex;
  justify-content: center;
  flex-direction: column;
  line-height: normal;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: -32px;
    width: 100%;
    height: 32px;
  }
  .box-item {
    margin: 0 36px;
    &:hover {
      opacity: 0.8;
    }
    &.on {
      .m-link-a {
        color: #5297e0;
      }
    }
    & + .box-item {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        margin-top: -8px;
        left: -36px;
        background-color: #e0e0e0;
        width: 2px;
        height: 16px;
      }
    }
    .m-link-a {
      color: #979797;
      font-size: 16px;
    }
  }
}
.header-tel {
  margin-left: 25px;
  position: relative;
  &:hover {
    .header-tel-box {
      display: flex;
    }
  }
}
.header-tel-ico {
  background: url("../assets/img/ico_10.png") no-repeat;
  width: 30px;
  height: 30px;
}
.header-tel-box {
  display: none;
  position: absolute;
  top: 50px;
  right: -56px;
  background: url("../assets/img/ico_4.png") no-repeat;
  width: 280px;
  height: 80px;
  box-sizing: border-box;
  color: #333333;
  font-size: 18px;
  padding-top: 14px;
  justify-content: center;
  align-items: center;
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    top: -20px;
    left: 0;
    height: 34px;
  }
}
.menu-make {
  position: absolute;
  left: 0;
  top: 88px;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: -1;
  transition: height 0.2s;
}
.header-nave-box-item {
  color: #fff;
  font-size: 16px;
  padding: 10px 0;
  // line-height: 22px;
  cursor: pointer;
  text-align: center;
}
</style>
